import { AutoComplete, Space } from "antd";
import React, { FC, useEffect, useState } from "react";
import DefaultFormParserLayout from "../../../components/Layouts/default-form-parser-layout";
import Button from "../../../components/UI/Button";
import { useLoading } from "../../../context/LoadingProvider/useLoading";
import { notificationError } from "../../../services/notification";
import {
  GameDefinitionFilter,
  getGameDefinition,
  getGameDefinitionFilter,
} from "../../../services/reports";
import { Output } from "../../../services/types";
import { DefaultOptionType } from "antd/lib/select";
import Fuse from "fuse.js";
import { isString } from "../../../utils/stringUtils";
import SelectInput from "../../../components/UI/SelectInputGameDef";
import { ISelectOption } from "../../../components/UI/SelectInput/types";
import SmartSearch from "../../../components/UI/SmartSearch";

const { Option } = AutoComplete;

const ReportGameDefinition: FC = () => {
  const loading = useLoading();

  const [params, setParams] = useState({
    id: '',
    type: '',
    name: ''
  })
  const [report, setReport] = useState<string>("");
  const [filters, setFilters] = useState<ISelectOption[]>([]);
  const [selected, setSelected] = useState<ISelectOption["value"]>("");

  const disabled = !selected
  const htmldisabled = !selected || selected==='all'

  const refreshReport = async (output: Output = Output.HTML) => {
    loading.addLoading();

    const res = await getGameDefinition({
      output,
      form: selected,
    });

    if (Output.isHTML(output) && isString(res)) {
      setReport(res);
    }

    loading.removeLoading();
  };

  useEffect(() => {
    console.log(selected)

  },[selected])

  useEffect(() => {
    const initialize = async () => {
      try {
        const filters = await getGameDefinitionFilter();

        setFilters(filters.map((filter, i) => {
          return {name: filter.text , value: filter.value}
        }));

        setSelected(filters[0]?.value || "")

      } catch (e) {
        if (e instanceof Error) {
          notificationError("Could not get game definition filters", e.message);
        } else {
          notificationError("Could not get game definition filters");
        }
      }

    };

    initialize();
  }, []);

  return (
    <DefaultFormParserLayout html={report}>
      <Space direction="horizontal" size="middle" wrap align="center">

        <SelectInput
          style={{marginTop: 25}}
          autoFocus
          options={filters}
          onSelectChange={(e) => setSelected(e)}
          value={selected}
          width={400}
        />
        <Button
          disabled={htmldisabled}
          onClick={() => refreshReport()}
          type="primary"
        >
          Refresh
        </Button>

        <Button
          disabled={disabled}
          type="primary"
          onClick={() => refreshReport(Output.PDF)}
        >
          Save as PDF
        </Button>
      </Space>
    </DefaultFormParserLayout>
  );
};

export default ReportGameDefinition;
